import { useState } from "react";
import { heatTopics } from "@/mocks/site";

export default function HeatBoard() {
  const [tracked, setTracked] = useState<string[]>([]);
  const toggle = (name: string) =>
    setTracked((p) => (p.includes(name) ? p.filter((n) => n !== name) : [...p, name]));

  return (
    <section className="border-y border-background-200 bg-background-100/70">
      <div className="mx-auto max-w-[1400px] px-4 py-6 md:px-6">
        <div className="mb-5 flex flex-wrap items-end justify-between gap-2">
          <div>
            <h2 className="flex items-center gap-2 font-display text-xl font-black text-foreground-950 md:text-2xl">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-accent-500 text-base text-background-50">
                <i className="ri-fire-fill" />
              </span>
              今日风向标
              <span className="hidden rounded-sm bg-background-200 px-2 py-0.5 text-xs font-semibold text-foreground-600 sm:inline">
                事件热度即时榜
              </span>
            </h2>
            <p className="mt-1 text-[13px] text-foreground-500">
              按近 24 小时讨论增量排序，可点选 + 进追踪。
            </p>
          </div>
          <span className="flex items-center gap-1 text-xs text-foreground-500">
            <i className="ri-refresh-line text-primary-500" /> 每 30 分钟更新
          </span>
        </div>

        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {heatTopics.map((t, idx) => {
            const active = tracked.includes(t.name);
            return (
              <div
                key={t.name}
                className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-accent-300"
              >
                <span
                  className={`w-7 text-center font-display text-2xl font-black leading-none ${
                    idx === 0 ? "text-primary-500" : idx < 3 ? "text-accent-600" : "text-foreground-300"
                  }`}
                >
                  {String(idx + 1).padStart(2, "0")}
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-1.5">
                    <h3 className="truncate text-sm font-bold text-foreground-950">{t.name}</h3>
                    <i
                      className={`text-sm ${
                        t.dir === "up"
                          ? "ri-arrow-up-line text-primary-500"
                          : t.dir === "down"
                            ? "ri-arrow-down-line text-foreground-400"
                            : "ri-sparkling-2-fill text-accent-500"
                      }`}
                    />
                  </div>
                  <div className="mt-1 flex items-center justify-between gap-2 text-[11px] text-foreground-500">
                    <span>{t.note}</span>
                    <span>热度 {t.wave}</span>
                  </div>
                  <div className="mt-1.5 h-1 w-full overflow-hidden rounded-full bg-background-200">
                    <div
                      className="h-full rounded-full bg-gradient-to-r from-accent-500 to-primary-500"
                      style={{ width: `${t.wave}%` }}
                    />
                  </div>
                </div>
                <button
                  type="button"
                  aria-label={active ? "取消追踪" : "加入追踪"}
                  onClick={() => toggle(t.name)}
                  className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full border text-base transition-colors ${
                    active
                      ? "border-primary-500 bg-primary-500 text-background-50"
                      : "border-background-300 bg-background-100 text-foreground-600 hover:border-primary-400 hover:text-primary-500"
                  }`}
                >
                  <i className={active ? "ri-check-line" : "ri-add-line"} />
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}